<template>
    <div class="flex items-center justify-center h-full">
        <UCheckbox v-model="selected"/>
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import {IncomingDocument} from '@/types/IncomingDocument'
import {useAttachDocumentService} from '@/transaction/create-transaction/AttachDocument.service'
import {useTaskManager} from '@/task-manager/taskManager.service'

const {panelAwareToggleDocumentAttach} = useTaskManager()
const {isDocumentAttached} = useAttachDocumentService()

const props = defineProps({
    params: {
        type: Object as () => {
            data: IncomingDocument
        },
        required: true
    }
})

const currentDocumentIsAttached = computed(() => {
    return isDocumentAttached(props.params.data.documentMeta.uuid)
})

const selected = computed({
    get: () => currentDocumentIsAttached.value,
    set: () => {
        panelAwareToggleDocumentAttach(props.params.data)
    }
})


</script>

<style>
@reference "@/index.css";
@reference "tailwindcss";

</style>